import React from "react";
import { Col, Row } from "reactstrap";
import { ICandidateToResourceInstance } from "../../shared/model/candidate-to-resource-instance.model";

interface IProps {
  candidateToResourceInstance: ICandidateToResourceInstance;
}

export const HeaderResourceIncomplete = (props: IProps) => {
  const { candidateToResourceInstance } = props;
  return (
    <>
      <Row>
        <Col className="resource-header">
          <div className="title-resource">
            ¡Hola
            {candidateToResourceInstance?.candidate &&
              ` ${candidateToResourceInstance.candidate.person?.firstName} ${candidateToResourceInstance.candidate.person?.lastName}`}
            !
          </div>
          <div className="subtitle-resource mt-3">
            {candidateToResourceInstance.resourceToInstance?.resource?.name && (
              <h3>
                {candidateToResourceInstance.resourceToInstance?.resource?.name}
              </h3>
            )}
            {candidateToResourceInstance.resourceToInstance?.resource?.description && (
              <p className="text-left">
                {candidateToResourceInstance.resourceToInstance?.resource?.description}
              </p>
            )}
            <p>Completá las consignas a continuación</p>
          </div>
        </Col>
      </Row>
    </>
  );
};
